import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'teacher-peer-relationship',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './teacher-peer-relationship.component.html',
  styleUrl: './teacher-peer-relationship.component.css'
})
export class TeacherPeerRelationshipComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection5 = new EventEmitter<any>();

  yesNo = EYesNo;
  peerRelationshipForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "How well does this student get along with other students? *",
      formControlName: "peer_relationship_student",
    },
    {
      question: "Who are the student's friends? *",
      formControlName: "student_friends",
    },
    {
      question: "Are there students who do not get along with this student? *",
      formControlName: "student_enemies",
    },
    {
      question: "Has this student ever talked about being bullied, teased, or treated unfairly by others? *",
      formControlName: "bullying",
    }
  ]

  radioQuestions = [
    {
      id: 'peer_conflicts',
      questionText: "Have you observed or are you aware of conflicts or difficulties with peers? *",
      formControlName: 'peer_conflicts',
      infoFormControlName: 'peer_conflicts_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.teacherStaffInterviewData && this.teacherStaffInterviewData[question.formControlName] !== undefined
                           ? this.teacherStaffInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.teacherStaffInterviewData?.[question.infoFormControlName] || '', disabled: this.teacherStaffInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.teacherStaffInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.peerRelationshipForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.peerRelationshipForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.peerRelationshipForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }  

  savePeerRelationship(): void {
    if (this.peerRelationshipForm.valid) {
      this.onSaveSection5.emit(this.peerRelationshipForm.value);
    }
  }


}
